import {
  MentorRequestComponentByStatus as ComponentByStatus,
  MentorRequestViewStatus,
  SingleMentorRequestStatus,
} from 'redux/schemas/models/mentor-request';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import { MentorshipProgramRequest } from 'redux/schemas/models/mentorship-program-connections';
import { useMentorRequestContext } from './mentor-request-context';

import MentorRequestContainer from './mentor-request-container';
import MentorAvailableStatus from './mentor-request-status/mentor-available-status';
import MentorUnavailableStatus from './mentor-request-status/mentor-unavailable-status';
import PendingRequestMenteeView from './mentor-request-status/pending-request-mentee-view';
import PendingRequestMentorView from './mentor-request-status/pending-request-mentor-view';

import useMentorAvailability from 'athena/hooks/use-mentor-availability';

const getStatus = (
  role: MentoringProgramRole,
  request: MentorshipProgramRequest,
  isAvailable: boolean,
): MentorRequestViewStatus => {
  const state = request?.state;
  if (state === SingleMentorRequestStatus.PENDING) {
    return role === MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE
      ? MentorRequestViewStatus.PENDING_REQUEST
      : MentorRequestViewStatus.PENDING_REQUEST_MENTOR_VIEW;
  }

  return isAvailable
    ? MentorRequestViewStatus.AVAILABLE
    : MentorRequestViewStatus.UNAVAILABLE;
};

const COMPONENTS_BY_STATUS: Record<MentorRequestViewStatus, ComponentByStatus> = {
  [MentorRequestViewStatus.AVAILABLE]: () => <MentorAvailableStatus />,
  [MentorRequestViewStatus.UNAVAILABLE]: () => <MentorUnavailableStatus />,
  [MentorRequestViewStatus.PENDING_REQUEST]: () => <PendingRequestMenteeView />,
  [MentorRequestViewStatus.PENDING_REQUEST_MENTOR_VIEW]: () => <PendingRequestMentorView />,
};

const MentorRequestInfo = () => {
  const { request, role, participant } = useMentorRequestContext();
  const { isAvailable } = useMentorAvailability(participant);
  const status = getStatus(role, request, isAvailable);
  const Component = COMPONENTS_BY_STATUS[status];

  return (
    <MentorRequestContainer>
      <Component />
    </MentorRequestContainer>
  );
};

export default MentorRequestInfo;
